import actions from '../utils/restActions';


const albums = (state = {list: [], current: {}}, action) => {

    switch (action.type) {
    case actions.albums.index.status.success:
	return Object.assign({}, state, {list: action.data});
    case actions.albums.show.status.success:
	return Object.assign({}, state, {current: action.data});
    case actions.albums.show.status.request:
	return Object.assign({}, state, {current: {}});	
    default:
	return state;
    }
}

export default albums;



// WEBPACK FOOTER //
// ./src/reducers/Albums.js